<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Container Payments</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="3">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.StartDate"
                  label="From"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="record.StartDate"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.EndDate"
                  label="To"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="record.EndDate"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete
              name="salepaymentReportAccount"
              dense
              outlined
              v-model="PaymentMode"
              :items="accounts"
              label="Payment Mode"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete
              name="salesPaymentReportCustomer"
              dense
              outlined
              v-model="record.CustomerID"
              :items="customers"
              label="Customer"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="4" class="mb-3">
            <v-btn color="accent" :loading="loader" @click="getReport"
              >Query Data</v-btn
            >
            <v-btn style="float: right" icon @click="printDoc">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- payments table -->

        <v-row dense>
          <v-col cols="12" v-show="role == 3 || role == 2" v-if="TotalAmount">
            <span class="totals"
              >Total Payments: {{ TotalAmount.toLocaleString() }}</span
            >
          </v-col>

          <v-col cols="12">
            <v-text-field
              label="Search"
              v-model="search"
              outlined
              dense
            ></v-text-field>
            <v-data-table
              :mobile-breakpoint="0"
              :headers="headers"
              :items="reportData"
              :search="search"
            >
              <template v-slot:item.SumApplied="{ item }">
                <span>{{ item.SumApplied.toLocaleString() }}</span>
              </template>

              <template v-slot:item.DocDate="{ item }">
                <span
                  style="display: inline-block; min-width: 80px; width: 80px"
                  >{{ item.DocDate | date }}</span
                >
              </template>
            </v-data-table>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
          </v-col>
        </v-row>
        <!-- end of table -->
      </v-card-text>
      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  data() {
    return {
      record: {},
      pageItems: 2000,
      updatedAccount: null,
      loader: false,
      editItem: {},
      editDialog: false,
      PaymentMode: null,
      accounts: [],
      customers: [],
      search: null,
      menu1: false,
      menu2: false,
      reportData: [],
      TotalAmount: null,
      returnPayments: [],
      TotalReturns: null,
      headers: [
        { text: "Customer", value: "ocrd.Name" },
        { text: "Phone No.", value: "ocrd.PhoneNumber" },
        { text: "Amount", value: "SumApplied" },
        { text: "Payment Mode", value: "oact.Name" },
        { text: "REF/ Remarks", value: "PaymentRemarks" },
        { text: "Container", value: "cargo.Name" },
        { text: "Date", value: "DocDate" },
      ],
      returnHeaders: [
        { text: "Customer", value: "ocrd" },
        { text: "Amount", value: "SumApplied" },
        { text: "Payment Mode", value: "oact" },
        { text: "Date", value: "DocDate" },
      ],
    };
  },
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    totalPayments() {
      let total = 0;
      if (this.TotalAmount) {
        total = this.TotalAmount.toLocaleString();
      }
      return total;
    },
  },
  methods: {
    openDialog(item) {
      this.editItem = item;
      this.editDialog = true;
    },
    setStartDate(date) {
      this.record.StartDate = date;
    },
    setEndDate(date) {
      this.record.EndDate = date;
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      const recordData = this.record;
      const storeId = this.activeStore;
      const self = this;
      const data = {
        store_id: storeId,
        PaymentMode: self.PaymentMode,
        SoldBy: null,
        CustomerID: recordData.CustomerID,
        StartDate: recordData.StartDate,
        EndDate: recordData.EndDate,
      };
      const url = "/container/payments";
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.reportData = res.ResponseData.AllPayments;
            self.TotalAmount = res.ResponseData.TotalAmount;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });

      // get cancelled
      const cancelUrl = `/cancelled-payments-report`;
      this.$store
        .dispatch("post", { url: cancelUrl, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.returnPayments = res.ResponseData.AllPayments;
            self.TotalReturns = res.ResponseData.TotalReturns;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printDoc() {
      if (this.record.StartDate == null || this.record.EndDate == null) {
        this.$refs.snackbar.show("Please select both dates", "red");
      } else {
        this.print();
      }
    },
    print() {
      const shopName = this.storeName;
      var doc = new jsPDF({ compress: true });
      var totalPagesExp = "{total_pages_count_string}";
      // var pageHeight =
      //   doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      var img = new Image();
      img.src = require("@/assets/stock.png");
      doc.addImage(img, "png", 10, 5, 100, 40);

      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Georgia, serif");
      doc.text(shopName, pageWidth - 50, 15, "center");

      //Setting Items Title:
      doc.setFontSize(15);
      doc.text("Sales Payments", pageWidth / 2, 57, "center");

      doc.setFontSize(13);
      doc.text(
        `From: ${this.record.StartDate}  To:  ${this.record.EndDate}`,
        pageWidth / 2,
        62,
        "center"
      );
      doc.setFontSize(12);

      // Vairables to Hold Data
      let dataRows = [];
      let dataSummaryRows = [];

      // Columns
      var columns = [
        { title: "Customer", dataKey: "Name" },
        { title: "Total Amount", dataKey: "DocTotal" },
        { title: "Doc Date", dataKey: "DocDate" },
      ];

      function dataSummaryColumns() {
        return [
          {
            count: "",
            name: "Amount",
          },
        ];
      }

      const TotalAmount = {
        count: "Total Sales/Pucharse",
        name: this.TotalAmount.toLocaleString(),
      };

      dataSummaryRows.push(TotalAmount);

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("SUMMARY", 15, 68);
      doc.autoTable({
        head: dataSummaryColumns(),
        body: dataSummaryRows,
        theme: "grid",
        tableWidth: 80,
        columnStyles: {
          count: {
            fontStyle: "bold",
          },
        },
        startY: 70,
        styles: { overflow: "hidden", cellPadding: 1, font: "Georgia, serif" },
        margin: { right: 100 },
      });

      const allSales = this.reportData;
      dataRows = allSales.map((alldata) => {
        return {
          Name: alldata.ocrd.Name,
          DocTotal: alldata.CashSum.toLocaleString(),
          DocDate: alldata.DocDate,
        };
      });

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("DOCUMENTS", 15, doc.autoTable.previous.finalY + 8);
      doc.autoTable(columns, dataRows, {
        theme: "grid",
        startY: doc.autoTable.previous.finalY + 13,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
          //Setting Foouter
          doc.setTextColor(22, 160, 133);
          doc.setFontSize(10);
          var today = new Date();
          doc.text("" + today, pageWidth / 2, pageHeight - 5, "center");
        },
      });
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }
      doc.save("Sales-payments.pdf");
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getAccounts();
    this.getCustomers();
  },
};
</script>

<style lang="scss" scoped>
</style>